import type { EdgeOrigin } from './backend'

/** The edge Worker is the page's own origin (static assets and /api/* are one Worker), over http(s) and ws(s). */
export function edgeOriginOf(location: Location): EdgeOrigin {
  return { http: location.origin, ws: location.origin.replace(/^http/, 'ws') }
}
